export default __webpack_public_path__ + "static/media/icono-mapa.2955e5f7.svg";